// extracted by mini-css-extract-plugin
export default {"assemblyView":"view_assembly_assemblyView__JHO17"};